import CreationSection from "./CreationSection";
import DetailsSection from "./DetailsSection";

const ReceiptDocumentsSection = {
    Creation: CreationSection,
    Details: DetailsSection,
};

export default ReceiptDocumentsSection;
